// extracted by mini-css-extract-plugin
export default {"statusDot":"contactPossibilities_statusDot__Va49A","statusDotOffline":"contactPossibilities_statusDotOffline__oj6Uq"};